export const packages = [
  {
    packageType: 5,
    offeringIdentifier: "all-access",
    identifier: "$rc_monthly",
    product: {
      description: "Monthly subscription to Wahoo",
      productType: 3,
      period: {
        value: 1,
        unit: 2,
      },
      trialLength: {
        value: 2,
        unit: 1,
      },
      priceString: "$17.99",
      currencyCode: "USD",
      price: 17.99,
      title: "Wahoo",
      identifier: "WAHOO_MONTHLY_IOS",
      trialAvailable: true,
    },
  },
  {
    packageType: -1,
    offeringIdentifier: "all-access",
    identifier: "wahoo_core_monthly",
    product: {
      description: "Monthly subscription including Wahoo training metrics",
      price: 4.99,
      currencyCode: "USD",
      priceString: "$4.99",
      trialLength: {
        unit: 1,
        value: 2,
      },
      period: {
        unit: 2,
        value: 1,
      },
      title: "Wahoo Core",
      trialAvailable: true,
      identifier: "wahoo_app_ios_core_monthly",
      productType: 3,
    },
  },
];

export const customerInfo = {
  entitlements: {
    all: {
      "core-access": {
        identifier: "core-access",
        isActive: true,
        willRenew: true,
        periodType: "normal",
        latestPurchaseDate: "2026-05-20T18:43:35Z",
        originalPurchaseDate: "2026-05-20T18:43:35Z",
        expirationDate: "2026-05-20T18:53:07Z",
        store: "play_store",
        productIdentifier: "wahoo_subscription",
        productPlanIdentifier: "wahoo-core-monthly",
        isSandbox: true,
        ownershipType: "UNKNOWN",
        verification: "VERIFIED",
      },
      "full-access": {
        identifier: "full-access",
        isActive: false,
        willRenew: true,
        periodType: "normal",
        latestPurchaseDate: "2026-05-20T18:43:04Z",
        originalPurchaseDate: "2026-05-20T18:43:35Z",
        expirationDate: "2026-05-20T18:43:35Z",
        store: "play_store",
        productIdentifier: "wahoo_subscription",
        productPlanIdentifier: "wahoo-monthly",
        isSandbox: true,
        ownershipType: "UNKNOWN",
        verification: "VERIFIED",
      },
    },
    verification: "VERIFIED",
  },
  allExpirationDatesByProduct: {
    WAHOO_MONTHLY_IOS: "2025-03-18T21:28:08Z",
    "wahoo_subscription:wahoo-core-monthly": "2026-05-20T18:53:07Z",
  },
  allPurchaseDatesByProduct: {
    WAHOO_MONTHLY_IOS: "2025-03-18T21:23:08Z",
    "wahoo_subscription:wahoo-core-monthly": "2026-05-20T18:43:35Z",
  },
  requestDate: "2026-05-20T18:43:42Z",
  firstSeen: "2025-03-17T22:09:12Z",
  originalAppUserId: "21944",
  originalPurchaseDate: "2013-08-01T07:00:00Z",
};
